import React from 'react'
import Card, { CardActionArea, CardActions, CardContent } from '../../components/card'
import GroupIcon from '@mui/icons-material/Group';
import Typography from '../../components/typography'
import Box from '../../components/box';
import { useNavigate } from 'react-router-dom';

interface StudioCardProps {
  title: string
  coverPictureUrl: string
  rate: number
  maxOccupancy: number
  actions?: React.ReactNode
  navigateTo?: string
}

const StudioCard: React.FC<StudioCardProps> = (props) => {
  const { title, coverPictureUrl, rate, maxOccupancy, actions, navigateTo } = props
  const navigate = useNavigate()

  const handleOnClick = (): void => {
    if (navigateTo) {
      navigate(navigateTo)
    }
  }

  return (
    <Card>
      <CardActionArea onClick={handleOnClick}>
        <Box sx={{
          position: 'relative',
          width: '100%',
          aspectRatio: '4/3'
        }}>
          <img src={coverPictureUrl} alt='studio' style={{
            width: '100%',
            objectFit: 'cover',
            aspectRatio: '4/3'
          }} />
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundImage: 'linear-gradient(0deg, #141414 0%, rgba(0, 0, 0, 0) 50%)',
              borderRadius: '12px 12px 0 0'
            }}
          />
          <Typography
            position={'absolute'}
            bottom={12}
            left={12}
            fontSize={20}
            variant="h2"
          >
            {title.toUpperCase().length > 90 ? title.toUpperCase().slice(0, 90) + '...' : title.toUpperCase()}
          </Typography>
        </Box>
        <CardContent sx={{ mt: 1 }}>
          <Box display={'flex'} justifyContent={'space-between'}>
            <Box display={'flex'} gap={1} alignItems={'center'}>
              <Typography leftIcon={<GroupIcon />} variant='caption' fontSize={'16px'}> {maxOccupancy}</Typography>
            </Box>
            <Typography fontSize={'16px'} variant='caption'>${rate}/hr</Typography>
          </Box>
        </CardContent>
      </CardActionArea>
      {actions && (
        <CardActions sx={{
          mb: 1,
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 1
        }}>
          {actions}
        </CardActions>
      )}
    </Card>
  )
}

export default StudioCard
